import { createAction } from "@reduxjs/toolkit";

export const SelectYearAndClient = createAction("SELECT_YEAR_CLIENT");
export const SelectProfession = createAction("SELECT_PROFESSION");
export const SelectVariant = createAction("SELECT_VARIANT");
export const SelectTestModule = createAction("SELECT_TEST_MODULE");
export const ResetTest = createAction("RESET_TEST");
